
(() => {
  const COLORS = [
    { id: "P01", name: "Schwarz", hex: "#202020" },
    { id: "P02", name: "Anthrazit", hex: "#4B5052" },
    { id: "P03", name: "Grau", hex: "#7D8181" },
    { id: "P04", name: "Hellgrau", hex: "#B8B7B2" },
    { id: "P05", name: "Weiß", hex: "#EFEBDD" },
    { id: "P06", name: "Creme", hex: "#E3D5B3" },
    { id: "P07", name: "Beige", hex: "#C8AD86" },
    { id: "P08", name: "Taupe", hex: "#8C7767" },
    { id: "P09", name: "Braun", hex: "#69452F" },
    { id: "P10", name: "Dunkelbraun", hex: "#3E2B23" },
    { id: "P11", name: "Cognac", hex: "#A85E31" },
    { id: "P12", name: "Ocker", hex: "#A67721" },
    { id: "P13", name: "Oliv", hex: "#7B793D" },
    { id: "P14", name: "Khaki", hex: "#8B8060" },
    { id: "P15", name: "Neon-Gelb", hex: "#E5ED12" },
    { id: "P16", name: "Gelb", hex: "#E6B813" },
    { id: "P17", name: "Orange", hex: "#D9792E" },
    { id: "P18", name: "Rot", hex: "#C93032" },
    { id: "P19", name: "Bordeaux", hex: "#7C2936" },
    { id: "P20", name: "Koralle", hex: "#D96E5A" },
    { id: "P21", name: "Altrosa", hex: "#BE777D" },
    { id: "P22", name: "Rosa", hex: "#DF748F" },
    { id: "P23", name: "Pink", hex: "#E22C69" },
    { id: "P24", name: "Magenta", hex: "#B33B75" },
    { id: "P25", name: "Mauve", hex: "#8D596C" },
    { id: "P26", name: "Lila", hex: "#67517E" },
    { id: "P27", name: "Violett", hex: "#57347A" },
    { id: "P28", name: "Royalblau", hex: "#365FC5" },
    { id: "P29", name: "Navy", hex: "#273A70" },
    { id: "P30", name: "Hellblau", hex: "#5895A7" },
    { id: "P31", name: "Türkis", hex: "#22A6B6" },
    { id: "P32", name: "Petrol", hex: "#2D666C" },
    { id: "P33", name: "Mint", hex: "#61B798" },
    { id: "P34", name: "Salbei", hex: "#718B69" },
    { id: "P35", name: "Grün", hex: "#4E8255" },
    { id: "P36", name: "Waldgrün", hex: "#294A37" },
    // Musterfarben: echte Materialfotos als wiederholbare Textur
    // hex dient als Fallback, falls das Bild einmal nicht geladen werden kann.
    { id: "P37", name: "Pink-Schwarz", hex: "#C33A83", textureKey: "patternP37", textureFile: "copcopet-paracord-p37-pink-schwarz.jpg", textureScale: 0.38 },
    { id: "P38", name: "Schwarz-Reflex", hex: "#343A3D", textureKey: "patternP38", textureFile: "copcopet-paracord-p38-schwarz-reflex.jpg", textureScale: 0.34 },
    { id: "P39", name: "Neon Lime-Schwarz", hex: "#D9FF00", textureKey: "patternP39", textureFile: "copcopet-paracord-p39-neon-lime-schwarz.jpg", textureScale: 0.34 },
    { id: "P40", name: "Petrol-Rost", hex: "#3E91A1", textureKey: "patternP40", textureFile: "copcopet-paracord-p40-petrol-rost.jpg", textureScale: 0.34 },
    { id: "P41", name: "Neon Grün-Schwarz", hex: "#45E51A", textureKey: "patternP41", textureFile: "copcopet-paracord-p41-neon-gruen-schwarz.jpg", textureScale: 0.34 },
    { id: "P42", name: "Orange-Schwarz", hex: "#F45A00", textureKey: "patternP42", textureFile: "copcopet-paracord-p42-orange-schwarz.jpg", textureScale: 0.34 },
  ];

  // Lederfarben aus Shopify. Die Schlüssel werden mit norm() abgeglichen,
  // damit z. B. „Apfelgrün“ zuverlässig als „apfelgrun“ erkannt wird.
  const LEATHER_COLORS = {
    apfelgrun: "#afb556",
    braun: "#5C5149",
    cognac: "#c86e23bb",
    grau: "#949099",
    rot: "#bd2938f2",
    marineblau: "#70738d",
    schwarz: "#3E393A"
  };

  // Materialbilder für die Leder-Farbauswahl. Die Dateien müssen im
  // Shopify-Theme unter "Assets" mit genau diesen Namen vorhanden sein.
  const LEATHER_SWATCH_IMAGES = {
    apfelgrun: "copcopet-leder-apfelgruen.png",
    braun: "copcopet-leder-braun.png",
    cognac: "copcopet-leder-cognac.png",
    grau: "copcopet-leder-grau.png",
    rot: "copcopet-leder-rot.png",
    marineblau: "copcopet-leder-marineblau.png",
    schwarz: "copcopet-leder-schwarz.png"
  };

  // Beschlagbilder werden automatisch nach Produktart und bei Halsbändern
  // zusätzlich nach Verschlussart gewechselt.
  // Die Verschlussart kommt aus dem Produkt-Metafeld custom.verschlussart.
  // Ist das Metafeld leer, liefert Liquid automatisch "ring" als Default.
  const HARDWARE_SWATCH_IMAGES = {
    leine: {
      messing: "copcopet-beschlag-messing-leine.png",
      edelstahl: "copcopet-beschlag-edelstahl-leine.png",
      verchromt: "copcopet-beschlag-verchromt-leine.png"
    },
    halsband: {
      ring: {
        messing: "copcopet-beschlag-ring-messing.png",
        edelstahl: "copcopet-beschlag-ring-edelstahl.png",
        verchromt: "copcopet-beschlag-ring-verchromt.png"
      },
      dornschnalle: {
        messing: "copcopet-beschlag-dornschnalle-messing.png",
        edelstahl: "copcopet-beschlag-dornschnalle-edelstahl.png",
        verchromt: "copcopet-beschlag-dornschnalle-verchromt.png"
      },
      dornschliesse: {
        messing: "copcopet-beschlag-dornschliesse-messing.png",
        edelstahl: "copcopet-beschlag-dornschliesse-edelstahl.png",
        verchromt: "copcopet-beschlag-dornschliesse-verchromt.png"
      },
      klickverschluss: {
        verchromt: "copcopet-beschlag-klickverschluss-verchromt.png",
        vermessingt: "copcopet-beschlag-klickverschluss-messing.png"
      }
    }
  };

  const MATCHING_SET_KEY = "copcopetMatchingSetV1";

  function readMatchingSet() {
    try {
      const raw = window.sessionStorage.getItem(MATCHING_SET_KEY);
      if (!raw) return null;
      const data = JSON.parse(raw);
      if (!data || typeof data !== "object") return null;
      // Abwärtskompatibel zu v9.8.2–v9.8.4: Dort wurde ein Set immer vom Halsband gestartet.
      if (data.hasHalsband == null && data.hasLeine == null) {
        data.hasHalsband = true;
        data.hasLeine = false;
        data.sourceType = "halsband";
      }
      return data;
    } catch (_) {
      return null;
    }
  }

  function writeMatchingSet(data) {
    try {
      window.sessionStorage.setItem(MATCHING_SET_KEY, JSON.stringify(data));
      return true;
    } catch (_) {
      return false;
    }
  }

  function removeMatchingSet() {
    try {
      window.sessionStorage.removeItem(MATCHING_SET_KEY);
    } catch (_) {}
  }

  const money = cents =>
    new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(cents / 100);

  const norm = value => String(value || "")
    .toLocaleLowerCase("de-DE")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/ß/g, "ss");

  const isColorOption = name => {
    const n = norm(name);
    return n.includes("farbe") || n.includes("color") || n.includes("lederfarbe");
  };

  const isSizeOption = name => {
    const n = norm(name);
    return n.includes("grosse") || n.includes("groesse") || n.includes("size")
      || n.includes("umfang") || n.includes("lange") || n.includes("laenge");
  };

  function init(root) {
    if (root.dataset.cpcReady === "1") return;
    root.dataset.cpcReady = "1";
    root.dataset.cpcVersion = "9.8.14";

    const originMarker = document.createComment("copcopet-configurator-origin");
    root.parentNode.insertBefore(originMarker, root);

    const product = JSON.parse(root.querySelector("[data-cpc-product-json]").textContent);
    const addonHandle = String(root.dataset.addonHandle || "zusatz").trim();
    const productType = norm(root.dataset.productType).trim();
    const productLabel = String(root.dataset.productLabel || "Produkt").trim() || "Produkt";
    const configuredClosureType = norm(root.dataset.closureType).replace(/[^a-z0-9]+/g, " ").trim();
    const isLeine = productType === "leine";
    const isHalsband = productType === "halsband";
    const highVariantMode = isLeine && Number(product.variantsCount || 0) > 250;
    let optionValueMeta = product.options.map(opt => Array.isArray(opt.valueMeta) ? opt.valueMeta : []);
    let resolvedVariant = product.selectedVariant || null;
    let matchingSet = readMatchingSet();
    let addonProduct = null;
    let addonLoadError = null;

    const overlay = root.querySelector("[data-cpc-overlay]");
    const openBtn = root.querySelector("[data-cpc-open]");
    const launchPriceEl = root.querySelector("[data-cpc-launch-price]") || openBtn?.querySelector(".cpc-launch__price");
    const closeBtn = root.querySelector("[data-cpc-close]");
    const canvas = root.querySelector("[data-cpc-canvas]");
    const ctx = canvas.getContext("2d");
    const stepsHost = root.querySelector("[data-cpc-steps]");
    const progressWrap = root.querySelector("[data-cpc-progress-wrap]");
    const stepLabel = root.querySelector("[data-cpc-step-label]");
    const content = root.querySelector("[data-cpc-content]");
    const backBtn = root.querySelector("[data-cpc-back]");
    const nextBtn = root.querySelector("[data-cpc-next]");

    const selectedVariant =
      product.variants.find(v => Number(v.id) === Number(product.selectedVariantId))
      || product.variants.find(v => v.available)
      || product.variants[0];

    const state = {
      step: 0,
      selections: product.options.map((opt, index) =>
        selectedVariant?.options?.[index] ?? opt.values?.[0] ?? null
      ),
      cordA: COLORS.find(c => c.id === "P03"),
      cordB: COLORS.find(c => c.id === "P02"),
      confirmed: false,
      busy: false,
      resolvingVariant: false,
      cartAdded: false,
      matchingPromptDismissed: false,
      matchingApplied: false,
      setComplete: false
    };

    // Build wizard definition directly from Shopify options.
    // Die Lederoption wird nicht nur am Optionsnamen erkannt, sondern vor allem
    // an den tatsächlichen Werten (Apfelgrün, Braun, Cognac, ...). Das ist
    // robuster, wenn die Option z. B. nur „Farbe“, „Leder“ oder anders heißt.
    function leatherKeyForValue(value) {
      const n = norm(value).replace(/[^a-z0-9]+/g, " ").trim();
      if (!n) return null;

      // Exakter Treffer zuerst. Danach auch Werte wie „Cognac – Leder“ zulassen.
      if (LEATHER_COLORS[n]) return n;
      return Object.keys(LEATHER_COLORS).find(name =>
        n === name || n.startsWith(name + " ") || n.endsWith(" " + name) || n.includes(" " + name + " ")
      ) || null;
    }

    function leatherHexForValue(value) {
      const key = leatherKeyForValue(value);
      return key ? LEATHER_COLORS[key] : null;
    }

    function hardwareKeyForValue(value) {
      const n = norm(value).replace(/[^a-z0-9]+/g, " ").trim();
      if (!n) return null;

      // Beim Alu-Klickverschluss heißen die Shopify-Werte "Glänzend" und "Vermessingt".
      // "Glänzend" nutzt dabei weiterhin das vorhandene verchromte Klickverschluss-Bild.
      if (/\bvermessingt(?:e[rsnm]?)?\b/.test(n)) return "vermessingt";
      if (/\bglanzend(?:e[rsnm]?)?\b/.test(n)) return "verchromt";
      if (/\bmessing\b/.test(n)) return "messing";
      if (/\bedelstahl\b/.test(n)) return "edelstahl";
      if (/\bverchromt(?:e[rsnm]?)?\b/.test(n) || /\bchrom\b/.test(n)) return "verchromt";
      return null;
    }

    function collarClosureType() {
      if (!isHalsband) return null;

      // Das Produkt-Metafeld custom.verschlussart ist die eindeutige Quelle.
      // Zulässige Werte: ring, dornschnalle, dornschliesse, klickverschluss.
      if (configuredClosureType.includes("dornschnalle")) return "dornschnalle";
      if (configuredClosureType.includes("dornschliesse")) return "dornschliesse";
      if (configuredClosureType.includes("klick")) return "klickverschluss";

      // Leer, "ring" oder unbekannt -> Ring als sicherer Default.
      return "ring";
    }

    function hardwareImageFileForValue(value) {
      const hardwareKey = hardwareKeyForValue(value);
      if (!hardwareKey) return null;

      if (isLeine) {
        return HARDWARE_SWATCH_IMAGES.leine?.[hardwareKey] || null;
      }

      if (isHalsband) {
        const closureKey = collarClosureType();
        return HARDWARE_SWATCH_IMAGES.halsband?.[closureKey]?.[hardwareKey] || null;
      }

      return null;
    }

    function leatherOptionScore(opt) {
      const values = Array.isArray(opt?.values) ? opt.values : [];
      const valueHits = values.reduce((sum, value) => sum + (leatherHexForValue(value) ? 1 : 0), 0);
      const n = norm(opt?.name);
      const nameBonus = n.includes("leder") ? 100 : (n.includes("farbe") || n.includes("color") ? 10 : 0);
      return valueHits * 1000 + nameBonus;
    }

    let leatherPreviewOptionIndex = -1;
    let bestLeatherScore = 0;
    product.options.forEach((opt, index) => {
      const score = leatherOptionScore(opt);
      if (score > bestLeatherScore) {
        bestLeatherScore = score;
        leatherPreviewOptionIndex = index;
      }
    });

    const colorOptionIndex = product.options.findIndex(opt => isColorOption(opt.name));
    const paracordAfter = colorOptionIndex >= 0
      ? colorOptionIndex
      : (leatherPreviewOptionIndex >= 0 ? leatherPreviewOptionIndex : Math.min(0, product.options.length - 1));

    function optionKind(name, values = []) {
      const n = norm(name).replace(/[^a-z0-9]+/g, " ").trim();
      if (values.some(value => leatherHexForValue(value))) return "leather";
      if (/\b(beschlag|beschlage|metall|hardware|karabiner|schnalle|ring|klickverschluss|verschluss)\b/.test(n)) return "hardware";
      return `name:${n}`;
    }

    function matchingSetAvailable() {
      if (!matchingSet || !matchingSet.cordA || !matchingSet.cordB) return false;
      const hasHalsband = Boolean(matchingSet.hasHalsband);
      const hasLeine = Boolean(matchingSet.hasLeine);
      if (isLeine) return hasHalsband && !hasLeine;
      if (isHalsband) return hasLeine && !hasHalsband;
      return false;
    }

    function matchingSourceLabel() {
      if (!matchingSet) return "deines anderen Produkts";
      if (matchingSet.hasHalsband && !matchingSet.hasLeine) return "deines Halsbands";
      if (matchingSet.hasLeine && !matchingSet.hasHalsband) return "deiner Leine";
      return "deines Sets";
    }

    function matchingTargetLabel() {
      return isLeine ? "Leine" : (isHalsband ? "Halsband" : "Produkt");
    }

    function storedOptionForCurrentOption(opt) {
      const n = norm(opt?.name);
      // Länge, Größe, Breite und sonstige Ausführung bleiben beim passenden Produkt bewusst frei wählbar.
      if (isSizeOption(opt?.name) || n.includes("breite") || n.includes("ausfuhrung")) return null;

      const stored = Array.isArray(matchingSet?.options) ? matchingSet.options : [];
      const kind = optionKind(opt?.name, opt?.values || []);

      if (kind === "leather" && matchingSet?.leatherValue) {
        return { name: "Lederfarbe", value: matchingSet.leatherValue };
      }
      if (kind === "hardware") {
        const exact = stored.find(item => norm(item?.name) === norm(opt?.name));
        return exact || stored.find(item => item?.kind === "hardware") || null;
      }
      return null;
    }

    async function applyMatchingSet() {
      if (!matchingSetAvailable()) return;

      const cordA = COLORS.find(c => c.id === matchingSet.cordA);
      const cordB = COLORS.find(c => c.id === matchingSet.cordB);
      if (cordA) state.cordA = cordA;
      if (cordB) state.cordB = cordB;

      const desired = state.selections.slice();
      const matchedIndexes = [];

      product.options.forEach((opt, index) => {
        const stored = storedOptionForCurrentOption(opt);
        if (!stored) return;
        const value = (opt.values || []).find(v => norm(v) === norm(stored.value));
        if (!value) return;
        desired[index] = value;
        matchedIndexes.push(index);
      });

      state.matchingApplied = true;
      state.matchingPromptDismissed = true;

      if (highVariantMode && matchedIndexes.length) {
        state.selections = desired;
        state.resolvingVariant = true;
        renderPreview();
        render();
        try {
          // Preserve the complete transferred combination when possible. If the
          // target product doesn't offer it, keep the earliest transferred
          // option (normally leather color) and let Shopify choose a valid rest.
          const fullIds = optionValueIdsFor(state.selections);
          let fresh = fullIds ? await fetchHighVariantState(fullIds) : null;
          if (!fresh?.selectedVariant || fresh.selectedVariant.available === false) {
            const firstMatched = Math.min(...matchedIndexes);
            const partialIds = optionValueIdsFor(state.selections, firstMatched);
            if (partialIds) fresh = await fetchHighVariantState(partialIds);
          }
          applyHighVariantState(fresh);
        } catch (err) {
          console.error("[CopcoPet 9.8.12] Set-Farben konnten nicht aufgelöst werden", err);
          resolvedVariant = null;
        } finally {
          state.resolvingVariant = false;
          renderPreview();
          render();
        }
        return;
      }

      const exactVariant = product.variants.find(v =>
        v.available && v.options.every((value, index) => value === desired[index])
      );

      if (exactVariant) {
        state.selections = exactVariant.options.slice();
      } else if (matchedIndexes.length) {
        const ranked = product.variants
          .filter(v => v.available)
          .map(v => ({
            variant: v,
            score: matchedIndexes.reduce((sum, index) => sum + (v.options[index] === desired[index] ? 1 : 0), 0)
          }))
          .sort((a, b) => b.score - a.score);
        if (ranked[0]?.variant) state.selections = ranked[0].variant.options.slice();
      }

      renderPreview();
      render();
    }

    const wizard = [];
    product.options.forEach((opt, optionIndex) => {
      wizard.push({
        type: "option",
        optionIndex,
        title: opt.name
      });
      if (optionIndex === paracordAfter) {
        wizard.push({ type: "paracord", title: "Paracord" });
      }
    });
    if (!product.options.length) {
      wizard.push({ type: "paracord", title: "Paracord" });
    }
    wizard.push({ type: "summary", title: "Prüfen" });

    if (matchingSetAvailable() && openBtn) {
      const label = openBtn.querySelector("span:first-child");
      if (label) {
        label.textContent = isLeine
          ? "✨ Passende Leine zum Halsband gestalten"
          : "✨ Passendes Halsband zur Leine gestalten";
      }
    }

    // Preview assets. On mobile the preview is rendered landscape so the
    // collar uses the available horizontal space instead of standing upright.
    const images = {};
    const mobilePreview = window.matchMedia("(max-width: 790px)");

    function isMobilePreview() {
      return mobilePreview.matches;
    }

    function sizePreviewCanvas() {
      if (!images.base) return;
      const portraitWidth = images.base.naturalWidth;
      const portraitHeight = images.base.naturalHeight;

      canvas.width = isMobilePreview() ? portraitHeight : portraitWidth;
      canvas.height = isMobilePreview() ? portraitWidth : portraitHeight;
    }

    function drawPreviewImage(targetCtx, image) {
      if (isMobilePreview()) {
        targetCtx.save();
        targetCtx.translate(canvas.width, 0);
        targetCtx.rotate(Math.PI / 2);
        targetCtx.drawImage(image, 0, 0, canvas.height, canvas.width);
        targetCtx.restore();
      } else {
        targetCtx.drawImage(image, 0, 0, canvas.width, canvas.height);
      }
    }

    function currentConfiguratorScriptUrl() {
      const script = Array.from(document.scripts).find(el =>
        /copcopet-configurator\.js(?:[?#]|$)/i.test(el.src || "")
      );
      return script?.src || "";
    }

    function siblingAssetUrl(filename) {
      try {
        const scriptSrc = currentConfiguratorScriptUrl();
        if (!scriptSrc) return filename;
        const url = new URL(scriptSrc, window.location.href);
        url.pathname = url.pathname.replace(/[^/]+$/, filename);
        // Die Versions-Query der JS-Datei absichtlich beibehalten.
        // Shopify/CDNs cachen Assets aggressiv; so bekommen auch die
        // sibling-Bilder beim Aktualisieren des Konfigurators eine neue URL.
        url.hash = "";
        return url.toString();
      } catch (_) {
        return filename;
      }
    }

    // Wenn die neue Liquid-Zeile noch nicht eingebaut wurde, versucht v9.3
    // die Ledertextur automatisch neben der JS-Datei zu laden.
    const leatherSrc = root.dataset.previewLeather || siblingAssetUrl("copcopet-leather-texture.png");

    function patternImageKey(cord) {
      return `pattern_${cord.id}`;
    }

    function patternImageSrc(cord) {
      if (!cord?.textureKey) return null;
      return root.dataset[cord.textureKey] || siblingAssetUrl(cord.textureFile);
    }

    function loadPreviewImage(key, src, required = false) {
      return new Promise(resolve => {
        if (!src) {
          if (required) console.error(`[CopcoPet 9.8.12] Asset fehlt: ${key}`);
          resolve(null);
          return;
        }

        const img = new Image();
        img.onload = () => {
          images[key] = img;
          resolve(img);
        };
        img.onerror = () => {
          const log = required ? console.error : console.warn;
          log(`[CopcoPet 9.8.12] Asset konnte nicht geladen werden: ${key}`, src);
          resolve(null);
        };
        img.src = src;
      });
    }

    const patternLoaders = COLORS
      .filter(cord => cord.textureKey)
      .map(cord => loadPreviewImage(patternImageKey(cord), patternImageSrc(cord), false));

    Promise.all([
      loadPreviewImage("base", root.dataset.previewBase, true),
      loadPreviewImage("leather", leatherSrc, false),
      loadPreviewImage("a", root.dataset.previewA, false),
      loadPreviewImage("b", root.dataset.previewB, false),
      ...patternLoaders
    ]).then(() => {
      if (!images.base) return;
      sizePreviewCanvas();
      renderPreview();

      const option = leatherPreviewOptionIndex >= 0 ? product.options[leatherPreviewOptionIndex] : null;
      console.info("[CopcoPet 9.8.12] Leder-Vorschau", {
        option: option?.name || null,
        selected: leatherPreviewOptionIndex >= 0 ? state.selections[leatherPreviewOptionIndex] : null,
        leatherTextureLoaded: Boolean(images.leather)
      });
    });

    const handlePreviewBreakpoint = () => {
      if (!images.base) return;
      sizePreviewCanvas();
      renderPreview();
    };
    if (mobilePreview.addEventListener) {
      mobilePreview.addEventListener("change", handlePreviewBreakpoint);
    } else if (mobilePreview.addListener) {
      mobilePreview.addListener(handlePreviewBreakpoint);
    }

    function tintLayer(texture, color) {
      const temp = document.createElement("canvas");
      temp.width = canvas.width;
      temp.height = canvas.height;
      const t = temp.getContext("2d");

      t.fillStyle = color;
      t.fillRect(0, 0, temp.width, temp.height);
      t.globalCompositeOperation = "destination-in";
      drawPreviewImage(t, texture);

      ctx.globalCompositeOperation = "source-over";
      ctx.drawImage(temp, 0, 0);

      ctx.globalCompositeOperation = "overlay";
      drawPreviewImage(ctx, texture);
      ctx.globalCompositeOperation = "source-over";
    }

    // Muster werden zuerst im ursprünglichen (hochkantigen) Koordinatensystem
    // aufgebaut und erst danach zusammen mit der Paracord-Maske gedreht. So
    // folgt die Webstruktur auch auf Mobilgeräten der Ausrichtung des Halsbands.
    function patternLayer(mask, patternTexture, textureScale = 0.36) {
      const sourceWidth = mask.naturalWidth || images.base?.naturalWidth || canvas.width;
      const sourceHeight = mask.naturalHeight || images.base?.naturalHeight || canvas.height;
      const temp = document.createElement("canvas");
      temp.width = sourceWidth;
      temp.height = sourceHeight;
      const t = temp.getContext("2d");

      // Die Materialdateien sind bewusst hochauflösend. Für die Vorschau wird
      // daraus ein kleineres Kachelbild erzeugt. So bleibt das Muster fein und
      // wird nicht wie ein großes Foto in jedes Flechtsegment gespannt.
      const tile = document.createElement("canvas");
      const naturalWidth = patternTexture.naturalWidth || patternTexture.width || 768;
      const naturalHeight = patternTexture.naturalHeight || patternTexture.height || 768;
      const scale = Math.max(0.18, Math.min(0.65, Number(textureScale) || 0.36));
      tile.width = Math.max(96, Math.round(naturalWidth * scale));
      tile.height = Math.max(96, Math.round(naturalHeight * scale));
      const tileCtx = tile.getContext("2d");
      tileCtx.imageSmoothingEnabled = true;
      tileCtx.imageSmoothingQuality = "high";
      tileCtx.drawImage(patternTexture, 0, 0, tile.width, tile.height);

      const pattern = t.createPattern(tile, "repeat");
      if (!pattern) return;
      t.fillStyle = pattern;
      t.fillRect(0, 0, temp.width, temp.height);

      // Auf die vorhandene Paracord-Maske beschneiden.
      t.globalCompositeOperation = "destination-in";
      t.drawImage(mask, 0, 0, temp.width, temp.height);

      // Nur eine dezente Licht-/Schatteninformation der Originalmaske
      // zurückholen. Das Materialbild selbst trägt bereits Webstruktur.
      t.globalCompositeOperation = "soft-light";
      t.globalAlpha = 0.24;
      t.drawImage(mask, 0, 0, temp.width, temp.height);
      t.globalAlpha = 1;
      t.globalCompositeOperation = "source-over";

      ctx.save();
      ctx.globalCompositeOperation = "source-over";
      drawPreviewImage(ctx, temp);
      ctx.restore();
    }

    function renderCordLayer(mask, cord) {
      const patternTexture = cord?.textureKey ? images[patternImageKey(cord)] : null;
      if (patternTexture) {
        patternLayer(mask, patternTexture, cord.textureScale);
      } else {
        tintLayer(mask, cord?.hex || "#777777");
      }
    }

    // Separate Leder-Farbgebung: Das mittlere Grau der Textur bleibt nahezu
    // die gewählte HEX-Farbe. Dunkle Poren werden vertieft, helle Kanten
    // bekommen mehr Licht. Dadurch wirkt das Leder deutlich weniger flach,
    // ohne die eigentliche Shopify-Farbe zu verfälschen.
    function tintLeatherLayer(texture, color) {
      const temp = document.createElement("canvas");
      temp.width = canvas.width;
      temp.height = canvas.height;
      const t = temp.getContext("2d");

      // 1) Reine Lederfarbe, nur innerhalb der Leder-Maske.
      t.fillStyle = color;
      t.fillRect(0, 0, temp.width, temp.height);
      t.globalCompositeOperation = "destination-in";
      drawPreviewImage(t, texture);

      // 2) Narbung / Hell-Dunkel. Bei Overlay ist 50% Grau neutral.
      t.globalCompositeOperation = "overlay";
      t.globalAlpha = 0.92;
      drawPreviewImage(t, texture);

      // 3) Zweite, weichere Texturpassage für die feinen Lederfasern.
      t.globalCompositeOperation = "soft-light";
      t.globalAlpha = 0.58;
      drawPreviewImage(t, texture);

      t.globalAlpha = 1;
      t.globalCompositeOperation = "source-over";

      ctx.save();
      ctx.globalCompositeOperation = "source-over";
      ctx.filter = "saturate(1.05) contrast(1.04)";
      ctx.drawImage(temp, 0, 0);
      ctx.restore();
    }

    function selectedLeatherHex() {
      if (leatherPreviewOptionIndex < 0) return null;
      return leatherHexForValue(state.selections[leatherPreviewOptionIndex]);
    }

    function renderPreview() {
      if (!images.base) return;

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Basisbild neutralisieren:
      // ursprüngliches Pink/Grün kann dadurch nicht mehr durchscheinen
      ctx.save();
      ctx.filter = "grayscale(100%)";
      drawPreviewImage(ctx, images.base);
      ctx.restore();

      // Gewählte Lederfarbe auf die separate Leder-Textur legen.
      // So bleiben Licht, Schatten und Narbung des Leders erhalten.
      const leatherHex = selectedLeatherHex();
      if (images.leather && leatherHex) {
        tintLeatherLayer(images.leather, leatherHex);
      }

      // Gewählte Paracord-Farben darüber. Fehlende optionale Layer dürfen
      // die komplette Vorschau nicht mehr stoppen.
      if (images.a) renderCordLayer(images.a, state.cordA);
      if (images.b) renderCordLayer(images.b, state.cordB);
    }

    // Dynamischer JTL/Shopify-Zusatzartikel.
    // Halsband: "35 - 40 cm 20 mm" -> 40 cm -> Variante "40 cm".
    // Leine: unabhängig von der Länge immer -> Variante "Leine".
    function shopRoot() {
      return window.Shopify?.routes?.root || "/";
    }

    function extractEndLength(value) {
      const matches = Array.from(String(value || "").matchAll(/(\d+(?:[.,]\d+)?)\s*cm\b/gi));
      if (!matches.length) return null;
      const number = Number(matches[matches.length - 1][1].replace(",", "."));
      return Number.isFinite(number) ? number : null;
    }

    function selectedEndLength() {
      let best = null;

      product.options.forEach((opt, index) => {
        const value = state.selections[index];
        const length = extractEndLength(value);
        if (length == null) return;

        let score = 10;
        if (isSizeOption(opt?.name)) score += 100;
        if (/\bmm\b/i.test(String(value || ""))) score += 10;

        if (!best || score > best.score) {
          best = { length, score, optionIndex: index, value };
        }
      });

      return best?.length ?? null;
    }

    function priceToCents(rawPrice) {
      if (typeof rawPrice === "number" && Number.isFinite(rawPrice)) {
        // Shopify /products/{handle}.js liefert Geldwerte in Untereinheiten (Cent).
        return Math.round(rawPrice);
      }

      const text = String(rawPrice ?? "").trim().replace(/\s/g, "").replace(",", ".");
      if (!text) return null;
      const value = Number(text);
      if (!Number.isFinite(value)) return null;

      // Fallback für Product-JSON wie "19.99".
      return Math.round(value * 100);
    }

    function addonVariantLength(variant) {
      return extractEndLength(variant?.option1 ?? variant?.title ?? variant?.sku ?? "");
    }

    function addonVariantIsLeine(variant) {
      const candidates = [variant?.option1, variant?.title, variant?.sku];
      return candidates.some(value => norm(value).trim() === "leine");
    }

    function currentAddonSelection() {
      if (!isHalsband && !isLeine) {
        return {
          status: "unsupported-product",
          endLength: null,
          variant: null,
          price: null
        };
      }

      if (isLeine) {
        // 19,99 EUR nur als Anzeige-Fallback, bis Shopify geladen ist.
        // Für Warenkorb und Endpreis wird immer die echte Variante "Leine" verwendet.
        const estimatedPrice = 1999;

        if (!addonProduct) {
          return {
            status: addonLoadError ? "error" : "loading",
            endLength: null,
            variant: null,
            price: estimatedPrice
          };
        }

        const variant = (addonProduct.variants || []).find(addonVariantIsLeine) || null;
        if (!variant) {
          return { status: "missing-leine", endLength: null, variant: null, price: estimatedPrice };
        }

        const price = priceToCents(variant.price) ?? estimatedPrice;
        if (variant.available === false) {
          return { status: "unavailable-leine", endLength: null, variant, price };
        }

        return { status: "ready", endLength: null, variant, price };
      }

      const endLength = selectedEndLength();
      const estimatedPrice = endLength == null ? null : Math.round((endLength + 15) * 100);

      if (endLength == null) {
        return { status: "no-size", endLength: null, variant: null, price: null };
      }

      if (!addonProduct) {
        return {
          status: addonLoadError ? "error" : "loading",
          endLength,
          variant: null,
          price: estimatedPrice
        };
      }

      const variant = (addonProduct.variants || []).find(v => addonVariantLength(v) === endLength) || null;
      if (!variant) {
        return { status: "missing", endLength, variant: null, price: estimatedPrice };
      }

      const price = priceToCents(variant.price) ?? estimatedPrice;
      if (variant.available === false) {
        return { status: "unavailable", endLength, variant, price };
      }

      return { status: "ready", endLength, variant, price };
    }

    function addonErrorText(addon = currentAddonSelection()) {
      if (addon.status === "unsupported-product") {
        return "Für dieses Produkt ist der Konfigurator aktuell noch nicht eingerichtet.";
      }
      if (addon.status === "error") {
        return "Der Aufpreis für die Paracord-Einflechtung konnte gerade nicht geladen werden. Bitte lade die Seite neu.";
      }
      if (addon.status === "missing-leine") {
        return "Die Paracord-Einflechtung für Leinen ist aktuell nicht verfügbar.";
      }
      if (addon.status === "unavailable-leine") {
        return "Die Paracord-Einflechtung für Leinen ist aktuell nicht verfügbar.";
      }
      if (addon.status === "missing") {
        return "Für deine gewählte Halsbandgröße ist die Paracord-Einflechtung aktuell nicht verfügbar.";
      }
      if (addon.status === "unavailable") {
        return `Die Paracord-Einflechtung für ${addon.endLength} cm ist aktuell nicht verfügbar.`;
      }
      if (addon.status === "no-size") {
        return "Bitte wähle zuerst eine gültige Halsbandgröße aus.";
      }
      return "";
    }

    function updateLaunchPrice() {
      if (!launchPriceEl) return;
      const addon = currentAddonSelection();
      if (addon.price != null) {
        launchPriceEl.textContent = `+ ${money(addon.price)}`;
      } else if (isHalsband) {
        launchPriceEl.textContent = "Aufpreis nach Größe";
      } else {
        launchPriceEl.textContent = "Aufpreis wird geladen";
      }
    }

    async function loadAddonProduct() {
      try {
        const url = `${shopRoot()}products/${encodeURIComponent(addonHandle)}.js`;
        const response = await fetch(url, {
          method: "GET",
          headers: { "Accept": "application/json" },
          credentials: "same-origin"
        });
        const data = await response.json();
        if (!response.ok || !data || !Array.isArray(data.variants)) {
          throw new Error(data?.description || data?.message || `HTTP ${response.status}`);
        }

        addonProduct = data;
        addonLoadError = null;
        console.info("[CopcoPet 9.8.12] Dynamischer Zusatzartikel geladen", {
          handle: addonHandle,
          variants: data.variants.length
        });
      } catch (err) {
        addonProduct = null;
        addonLoadError = err instanceof Error ? err : new Error(String(err));
        console.error("[CopcoPet 9.8.12] Zusatzartikel konnte nicht geladen werden", addonLoadError);
      } finally {
        updateLaunchPrice();
        if (!overlay.hidden) render();
      }
    }

    const addonReady = loadAddonProduct();

    function sameOptions(a, b) {
      return Array.isArray(a) && Array.isArray(b)
        && a.length === b.length
        && a.every((value, index) => value === b[index]);
    }

    function currentVariant() {
      if (highVariantMode && resolvedVariant && sameOptions(resolvedVariant.options, state.selections)) {
        return resolvedVariant;
      }
      return product.variants.find(v =>
        v.options.every((value, index) => value === state.selections[index])
      ) || null;
    }

    function optionMeta(optionIndex, value) {
      return (optionValueMeta[optionIndex] || []).find(item => item.name === value) || null;
    }

    function optionValueIdsFor(selection, throughIndex = null) {
      const ids = [];
      for (let index = 0; index < selection.length; index += 1) {
        if (throughIndex != null && index > throughIndex) break;
        const meta = optionMeta(index, selection[index]);
        if (!meta?.id) return null;
        ids.push(meta.id);
      }
      return ids;
    }

    function candidatePossible(optionIndex, candidate) {
      if (highVariantMode) {
        const meta = optionMeta(optionIndex, candidate);
        // product_option_value.available is Shopify's supported availability source
        // for products with more than 250 variants.
        return meta ? meta.available !== false : true;
      }

      return product.variants.some(v => {
        if (!v.available) return false;
        return v.options.every((value, index) => {
          const expected = index === optionIndex ? candidate : state.selections[index];
          return value === expected;
        });
      });
    }

    async function fetchHighVariantState(ids) {
      if (!ids?.length) return null;
      const url = new URL(window.location.href);
      url.searchParams.delete("variant");
      url.searchParams.set("option_values", ids.join(","));
      url.hash = "";

      const response = await fetch(url.toString(), {
        credentials: "same-origin",
        cache: "no-store",
        headers: { "X-Requested-With": "XMLHttpRequest" }
      });
      if (!response.ok) throw new Error(`Variantenstatus konnte nicht geladen werden (${response.status})`);

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const jsonEl = doc.querySelector("[data-cpc-product-json]");
      if (!jsonEl) throw new Error("Variantenstatus fehlt in der Shopify-Antwort");
      return JSON.parse(jsonEl.textContent);
    }

    function applyHighVariantState(fresh) {
      if (!fresh) return false;
      optionValueMeta = fresh.options.map(opt => Array.isArray(opt.valueMeta) ? opt.valueMeta : []);
      resolvedVariant = fresh.selectedVariant || null;
      if (resolvedVariant?.options?.length === state.selections.length) {
        state.selections = resolvedVariant.options.slice();
      }
      return Boolean(resolvedVariant);
    }

    async function resolveHighVariantSelection(changedIndex) {
      const fullIds = optionValueIdsFor(state.selections);
      let fresh = null;

      // First preserve the buyer's current length / hardware if that exact
      // combination exists. If it doesn't, ask Shopify for the first valid
      // continuation below the changed option.
      if (fullIds) {
        fresh = await fetchHighVariantState(fullIds);
      }

      if (!fresh?.selectedVariant || fresh.selectedVariant.available === false) {
        const partialIds = optionValueIdsFor(state.selections, changedIndex);
        if (partialIds) fresh = await fetchHighVariantState(partialIds);
      }

      return applyHighVariantState(fresh);
    }

    async function pickOption(optionIndex, value) {
      state.selections[optionIndex] = value;

      if (highVariantMode) {
        state.resolvingVariant = true;
        renderPreview();
        render();
        try {
          await resolveHighVariantSelection(optionIndex);
        } catch (err) {
          console.error("[CopcoPet 9.8.12] High-Variant-Auswahl konnte nicht aufgelöst werden", err);
          resolvedVariant = null;
        } finally {
          state.resolvingVariant = false;
          renderPreview();
          render();
        }
        return;
      }

      // If the exact combination is unavailable, heal other option choices by
      // selecting the first available variant that contains the requested value.
      if (!currentVariant()?.available) {
        const fallback = product.variants.find(v =>
          v.available && v.options[optionIndex] === value
        );
        if (fallback) {
          state.selections = fallback.options.slice();
        }
      }
      renderPreview();
      render();
    }

    function randomizeParacord() {
      const a = COLORS[Math.floor(Math.random() * COLORS.length)];
      let b = COLORS[Math.floor(Math.random() * COLORS.length)];
      while (b.id === a.id && COLORS.length > 1) {
        b = COLORS[Math.floor(Math.random() * COLORS.length)];
      }
      state.cordA = a;
      state.cordB = b;
      renderPreview();
      render();
    }

    function escapeHtml(value) {
      return String(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    }

    function matchingOfferHtml() {
      if (!matchingSetAvailable() || state.matchingPromptDismissed || state.matchingApplied) return "";
      const a = COLORS.find(c => c.id === matchingSet.cordA);
      const b = COLORS.find(c => c.id === matchingSet.cordB);
      const combo = [a, b].filter(Boolean).map(c => `${c.id} ${c.name}`).join(" + ");
      const source = matchingSourceLabel();
      const target = matchingTargetLabel();
      return `
        <div class="cpc-match-card" data-cpc-match-card>
          <div class="cpc-match-card__eyebrow">Passendes Set</div>
          <strong class="cpc-match-card__title">Farben ${escapeHtml(source)} übernehmen?</strong>
          <p>Deine gespeicherte Kombination${combo ? ` <strong>${escapeHtml(combo)}</strong>` : ""} kann direkt für ${target === "Leine" ? "diese Leine" : "dieses Halsband"} übernommen werden.</p>
          <div class="cpc-match-card__actions">
            <button type="button" class="cpc-match-card__apply" data-cpc-match-apply>Farben übernehmen</button>
            <button type="button" class="cpc-match-card__dismiss" data-cpc-match-dismiss>Nicht jetzt</button>
          </div>
        </div>`;
    }

    function matchingAppliedHtml() {
      if (!(isLeine || isHalsband) || !state.matchingApplied || state.step !== 0) return "";
      const source = matchingSourceLabel();
      const freeChoice = isLeine ? "Länge und Ausführung" : "Größe und Ausführung";
      return `
        <div class="cpc-match-confirmed">
          <span aria-hidden="true">✓</span> Farben ${escapeHtml(source)} wurden übernommen. ${freeChoice} kannst du jetzt frei wählen.
        </div>`;
    }

    function bindMatchingOffer(stepEl) {
      const apply = stepEl.querySelector("[data-cpc-match-apply]");
      const dismiss = stepEl.querySelector("[data-cpc-match-dismiss]");
      if (apply) apply.addEventListener("click", () => { void applyMatchingSet(); });
      if (dismiss) {
        dismiss.addEventListener("click", () => {
          state.matchingPromptDismissed = true;
          render();
        });
      }
    }

    function optionStepHtml(def, stepNumber) {
      const opt = product.options[def.optionIndex];
      const isLeatherStep = def.optionIndex === leatherPreviewOptionIndex;
      const isHardwareStep = optionKind(opt.name, opt.values || []) === "hardware";
      const intro = isLeatherStep
        ? (isLeine
          ? "Wähle deine Lederfarbe – die Vorschau passt sich direkt an."
          : `Wähle deine Lederfarbe – deine ${escapeHtml(productLabel)}-Vorschau passt sich direkt an.`)
        : (isHardwareStep
          ? (isLeine
            ? "Wähle deinen Beschlag – bei Leinen zeigen wir dir den passenden Karabiner."
            : (isHalsband
              ? (collarClosureType() === "klickverschluss"
                ? "Wähle deinen Alu-Klickverschluss – die Vorschau zeigt die passende Oberfläche."
                : "Wähle deinen Beschlag – die Vorschau zeigt den passenden Beschlag zu diesem Halsband.")
              : "Wähle deinen Beschlag."))
          : "Wähle die Ausführung, die am besten zu deinem Wunschdesign passt.");
      const sizeNote = isSizeOption(opt.name)
        ? `<div class="cpc-size-note">
             <strong>Bitte sorgfältig auswählen</strong>
             ${isLeine ? "Deine Leine" : "Dein Halsband"} wird speziell für dich angefertigt.
             Prüfe deshalb ${isLeine ? "Länge und Ausführung" : "die Größe"} vor dem Bestellen noch einmal in Ruhe.
           </div>`
        : "";

      return `
        <div class="cpc-step">
          <h3>${stepNumber}. ${escapeHtml(opt.name)} auswählen</h3>
          <p class="cpc-step-intro">${intro}</p>
          <div class="cpc-choice-grid${isLeatherStep ? " cpc-choice-grid--leather" : ""}${isHardwareStep ? " cpc-choice-grid--hardware" : ""}" data-dynamic-option="${def.optionIndex}"></div>
          ${sizeNote}
        </div>`;
    }

    function paracordStepHtml(stepNumber) {
      const addon = currentAddonSelection();
      const priceText = addon.price != null ? money(addon.price) : (isLeine ? "19,99 €" : "nach gewählter Größe");
      const detailText = isLeine
        ? `Der Aufpreis für die Paracord-Einflechtung beträgt immer <strong>${priceText}</strong> – unabhängig von der Leinenlänge.`
        : `Der Aufpreis für die Paracord-Einflechtung beträgt bei deiner gewählten Größe <strong>${priceText}</strong>.`;

      return `
        <div class="cpc-step">
          <h3>${stepNumber}. Paracord gestalten</h3>
          <p class="cpc-step-intro">
            Stell deine Lieblingskombination aus zwei Paracord-Farben oder Mustern zusammen. ${detailText}
          </p>
          <div class="cpc-color-note">
            Die Vorschau zeigt die Farbrichtung möglichst realistisch. Je nach Bildschirm und Licht kann das echte Material leicht abweichen.
          </div>

          <div class="cpc-cord-block">
            <div class="cpc-cord-head">
              <strong>Paracord A</strong>
              <span class="cpc-cord-name" data-cord-a-name></span>
            </div>
            <div class="cpc-swatches" data-cord-a></div>
          </div>

          <div class="cpc-cord-block">
            <div class="cpc-cord-head">
              <strong>Paracord B</strong>
              <span class="cpc-cord-name" data-cord-b-name></span>
            </div>
            <div class="cpc-swatches" data-cord-b></div>
          </div>

          <button type="button" class="cpc-random" data-random>🎲 Überrasch mich</button>
        </div>`;
    }

    function summaryStepHtml(stepNumber) {
      const articleNoun = isLeine ? "Diese Leine" : "Dieses Halsband";
      return `
        <div class="cpc-step">
          <h3>${stepNumber}. Deine Auswahl</h3>
          <p class="cpc-step-intro">
            Fast geschafft! Prüfe deine Auswahl und deine beiden Paracord-Farben noch einmal.
          </p>

          <div class="cpc-summary" data-summary></div>

          <div class="cpc-pricebox">
            <div class="cpc-price-line"><span>${escapeHtml(productLabel)}</span><strong data-product-price>—</strong></div>
            <div class="cpc-price-line"><span>Paracord-Einflechtung</span><strong data-addon-price>—</strong></div>
            <div class="cpc-price-line cpc-price-total"><span>Gesamt</span><strong data-total>—</strong></div>
          </div>

          <div class="cpc-legal">
            <strong>Individuelle Anfertigung</strong>
            ${articleNoun} wird speziell nach deiner Auswahl für dich angefertigt.
            Bitte beachte: Für individuell angefertigte Produkte besteht gemäß § 312g Abs. 2 Nr. 1 BGB kein Widerrufsrecht.
          </div>

          <label class="cpc-confirm">
            <input type="checkbox" data-confirm>
            <span>Ich habe meine Auswahl – insbesondere ${isLeine ? "Länge und Ausführung" : "die Größe"} – geprüft und bestätige die individuelle Anfertigung.</span>
          </label>

          <div class="cpc-error" data-variant-error>
            Diese Kombination ist aktuell leider nicht verfügbar.
          </div>
          <div class="cpc-error" data-addon-error></div>
          <div class="cpc-error" data-cart-error></div>
        </div>`;
    }

    function renderChoiceButtons(stepEl, def) {
      if (def.type !== "option") return;
      const opt = product.options[def.optionIndex];
      const host = stepEl.querySelector(`[data-dynamic-option="${def.optionIndex}"]`);
      host.innerHTML = "";

      const isHardwareStep = optionKind(opt.name, opt.values || []) === "hardware";

      opt.values.forEach(value => {
        const btn = document.createElement("button");
        const leatherHex = def.optionIndex === leatherPreviewOptionIndex ? leatherHexForValue(value) : null;
        const hardwareImageFile = isHardwareStep ? hardwareImageFileForValue(value) : null;
        const hardwareImageUrl = hardwareImageFile ? siblingAssetUrl(hardwareImageFile) : null;
        btn.type = "button";
        btn.className = "cpc-choice"
          + (leatherHex ? " cpc-choice--leather" : "")
          + (isHardwareStep ? " cpc-choice--hardware" : "")
          + (state.selections[def.optionIndex] === value ? " is-selected" : "");
        btn.disabled = !candidatePossible(def.optionIndex, value);

        if (leatherHex) {
          const leatherKey = leatherKeyForValue(value);
          const leatherImageFile = leatherKey ? LEATHER_SWATCH_IMAGES[leatherKey] : null;
          const leatherImageUrl = leatherImageFile ? siblingAssetUrl(leatherImageFile) : null;

          btn.style.setProperty("--leather-swatch", leatherHex);
          if (leatherImageUrl) {
            btn.style.setProperty("--leather-swatch-image", `url("${leatherImageUrl}")`);
          }

          btn.innerHTML = `
            <span class="cpc-choice__main">
              <span class="cpc-leather-swatch" aria-hidden="true"></span>
              <span class="cpc-choice__label">${escapeHtml(value)}</span>
            </span>
            <span class="cpc-choice__check"></span>`;
        } else if (isHardwareStep && hardwareImageUrl) {
          btn.style.setProperty("--hardware-swatch-image", `url("${hardwareImageUrl}")`);
          btn.innerHTML = `
            <span class="cpc-choice__main">
              <span class="cpc-hardware-swatch" aria-hidden="true"></span>
              <span class="cpc-choice__label">${escapeHtml(value)}</span>
            </span>
            <span class="cpc-choice__check"></span>`;
        } else {
          btn.innerHTML = `<span>${escapeHtml(value)}</span><span class="cpc-choice__check"></span>`;
        }

        btn.addEventListener("click", () => { void pickOption(def.optionIndex, value); });
        host.appendChild(btn);
      });
    }

    function renderSwatches(stepEl) {
      const aHost = stepEl.querySelector("[data-cord-a]");
      const bHost = stepEl.querySelector("[data-cord-b]");
      if (!aHost || !bHost) return;

      const paint = (host, key, nameTarget) => {
        host.innerHTML = "";
        COLORS.forEach(c => {
          const btn = document.createElement("button");
          btn.type = "button";
          const patternSrc = c.textureKey ? patternImageSrc(c) : null;
          btn.className = "cpc-swatch"
            + (c.textureKey ? " cpc-swatch--pattern" : "")
            + (state[key].id === c.id ? " is-selected" : "");
          btn.style.setProperty(
            "--swatch",
            patternSrc ? `url("${patternSrc}") center / cover no-repeat` : c.hex
          );
          btn.title = `${c.id} · ${c.name}${c.textureKey ? " · Muster" : ""}`;
          btn.setAttribute("aria-label", btn.title);
          btn.addEventListener("click", () => {
            state[key] = c;
            renderPreview();
            render();
          });
          host.appendChild(btn);
        });
        nameTarget.textContent = `${state[key].id} · ${state[key].name}`;
      };

      paint(aHost, "cordA", stepEl.querySelector("[data-cord-a-name]"));
      paint(bHost, "cordB", stepEl.querySelector("[data-cord-b-name]"));

      stepEl.querySelector("[data-random]").addEventListener("click", randomizeParacord);
    }

    function renderSummary(stepEl) {
      const host = stepEl.querySelector("[data-summary]");
      if (!host) return;

      const rows = product.options.map((opt, index) =>
        `<div class="cpc-summary__row">
           <span>${escapeHtml(opt.name)}</span>
           <strong>${escapeHtml(state.selections[index] ?? "—")}</strong>
         </div>`
      );

      rows.push(
        `<div class="cpc-summary__row">
           <span>Paracord</span>
           <strong>${state.cordA.id} ${escapeHtml(state.cordA.name)} + ${state.cordB.id} ${escapeHtml(state.cordB.name)}</strong>
         </div>`
      );

      host.innerHTML = rows.join("");

      const variant = currentVariant();
      const addon = currentAddonSelection();
      stepEl.querySelector("[data-product-price]").textContent = variant ? money(variant.price) : "—";
      stepEl.querySelector("[data-addon-price]").textContent = addon.price != null ? money(addon.price) : "—";
      stepEl.querySelector("[data-total]").textContent = variant && addon.price != null
        ? money(variant.price + addon.price)
        : "—";

      const err = stepEl.querySelector("[data-variant-error]");
      err.classList.toggle("is-visible", !variant || !variant.available);

      const addonErr = stepEl.querySelector("[data-addon-error]");
      const addonMessage = addonErrorText(addon);
      addonErr.textContent = addonMessage;
      addonErr.classList.toggle("is-visible", Boolean(addonMessage));

      const confirm = stepEl.querySelector("[data-confirm]");
      confirm.checked = state.confirmed;
      confirm.addEventListener("change", e => {
        state.confirmed = e.target.checked;
        renderActions();
      });
    }

    function renderProgress() {
      progressWrap.style.gridTemplateColumns = `repeat(${wizard.length}, 1fr)`;
      progressWrap.innerHTML = wizard.map((_, index) =>
        `<span class="cpc-progress__item ${index < state.step ? "is-done" : ""} ${index === state.step ? "is-current" : ""}"></span>`
      ).join("");
      stepLabel.textContent = `Schritt ${state.step + 1} von ${wizard.length}`;
    }

    function renderActions() {
      const successMode = Boolean(state.cartAdded && (isHalsband || isLeine));
      root.classList.toggle("cpc-success-mode", successMode);

      if (successMode) {
        backBtn.style.display = "inline-flex";
        backBtn.textContent = "Zum Warenkorb";
        backBtn.style.gridColumn = state.setComplete ? "1 / -1" : "";
        if (state.setComplete) {
          nextBtn.style.display = "none";
        } else {
          nextBtn.style.display = "inline-flex";
          nextBtn.textContent = isHalsband ? "Passende Leine gestalten" : "Passendes Halsband gestalten";
          nextBtn.disabled = false;
        }
        return;
      }

      nextBtn.style.display = "inline-flex";
      backBtn.style.gridColumn = "";
      const isFirst = state.step === 0;
      const isLast = state.step === wizard.length - 1;
      const variant = currentVariant();
      const addon = currentAddonSelection();
      const addonReadyForCart = addon.status === "ready" && addon.variant && addon.price != null;

      backBtn.textContent = "Zurück";
      backBtn.style.display = isFirst ? "none" : "inline-flex";

      if (!isLast) {
        nextBtn.textContent = state.resolvingVariant ? "Auswahl wird geladen…" : "Weiter";
        nextBtn.disabled = state.resolvingVariant;
        return;
      }

      if (!variant || !variant.available) {
        nextBtn.textContent = "Nicht verfügbar";
      } else if (addon.status === "loading") {
        nextBtn.textContent = "Aufpreis wird geladen…";
      } else if (!addonReadyForCart) {
        nextBtn.textContent = "Auswahl prüfen";
      } else {
        nextBtn.textContent = `Für ${money(variant.price + addon.price)} in den Warenkorb`;
      }

      nextBtn.disabled = !state.confirmed || !variant || !variant.available || !addonReadyForCart || state.busy || state.resolvingVariant;
    }

    function render() {
      renderProgress();

      const def = wizard[state.step];
      let html = "";
      if (def.type === "option") html = optionStepHtml(def, state.step + 1);
      if (def.type === "paracord") html = paracordStepHtml(state.step + 1);
      if (def.type === "summary") html = summaryStepHtml(state.step + 1);

      stepsHost.innerHTML = html;
      const stepEl = stepsHost.firstElementChild;

      if ((isLeine || isHalsband) && state.step === 0) {
        const offer = matchingOfferHtml();
        const applied = matchingAppliedHtml();
        if (offer) stepEl.insertAdjacentHTML("afterbegin", offer);
        if (applied) stepEl.insertAdjacentHTML("afterbegin", applied);
        bindMatchingOffer(stepEl);
      }

      if (def.type === "option") renderChoiceButtons(stepEl, def);
      if (def.type === "paracord") renderSwatches(stepEl);
      if (def.type === "summary") renderSummary(stepEl);

      updateLaunchPrice();
      renderActions();
    }

    function newId(prefix) {
      const value = crypto.randomUUID
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
      return `${prefix}-${value}`;
    }

    function buildMatchingSet(setId) {
      const options = product.options.map((opt, index) => ({
        name: opt.name,
        value: state.selections[index],
        kind: optionKind(opt.name, opt.values || [])
      }));
      return {
        version: 2,
        setId,
        createdAt: Date.now(),
        sourceProductId: product.id,
        sourceTitle: product.title,
        sourceType: isLeine ? "leine" : (isHalsband ? "halsband" : productType),
        hasHalsband: Boolean(isHalsband),
        hasLeine: Boolean(isLeine),
        cordA: state.cordA.id,
        cordB: state.cordB.id,
        leatherValue: leatherPreviewOptionIndex >= 0 ? state.selections[leatherPreviewOptionIndex] : null,
        options
      };
    }

    function completedMatchingSet(base) {
      return {
        ...base,
        version: 2,
        hasHalsband: Boolean(base?.hasHalsband || isHalsband),
        hasLeine: Boolean(base?.hasLeine || isLeine)
      };
    }

    function renderSetSuccess() {
      progressWrap.innerHTML = "";
      progressWrap.style.gridTemplateColumns = "1fr";
      stepLabel.textContent = "";
      const combo = `${state.cordA.id} ${escapeHtml(state.cordA.name)} + ${state.cordB.id} ${escapeHtml(state.cordB.name)}`;

      if (state.setComplete) {
        stepsHost.innerHTML = `
          <div class="cpc-step cpc-success-step">
            <div class="cpc-success-icon" aria-hidden="true">✓</div>
            <h3>Dein Set ist komplett</h3>
            <p class="cpc-step-intro">Halsband und Leine sind jetzt gemeinsam im Warenkorb. Damit endet die Set-Erweiterung automatisch.</p>
            <div class="cpc-success-combo">
              <span>Deine Farbkombination</span>
              <strong>${combo}</strong>
            </div>
            <p class="cpc-success-hint">Du kannst dein Set jetzt im Warenkorb noch einmal in Ruhe prüfen.</p>
          </div>`;
      } else {
        const current = isHalsband ? "Halsband" : "Leine";
        const target = isHalsband ? "Leine" : "Halsband";
        const targetArticle = isHalsband ? "eine passende Leine" : "ein passendes Halsband";
        const freeChoice = isHalsband ? "Länge und Ausführung der Leine" : "Größe und Ausführung des Halsbands";
        stepsHost.innerHTML = `
          <div class="cpc-step cpc-success-step">
            <div class="cpc-success-icon" aria-hidden="true">✓</div>
            <h3>Dein ${current} ist im Warenkorb</h3>
            <p class="cpc-step-intro">Möchtest du ${targetArticle} im gleichen Design gestalten?</p>
            <div class="cpc-success-combo">
              <span>Gespeicherte Farbkombination</span>
              <strong>${combo}</strong>
            </div>
            <p class="cpc-success-hint">Beim ${target}-Konfigurator kannst du die Farben mit einem Klick übernehmen. ${freeChoice} wählst du trotzdem ganz frei.</p>
          </div>`;
      }
      renderActions();
    }

    async function addToCart() {
      await addonReady;

      const variant = currentVariant();
      const addon = currentAddonSelection();
      if (!variant || !variant.available || !state.confirmed || addon.status !== "ready" || !addon.variant) {
        const el = stepsHost.querySelector("[data-cart-error]");
        if (el) {
          el.textContent = addonErrorText(addon) || "Die Paracord-Einflechtung konnte für deine Auswahl nicht geladen werden.";
          el.classList.add("is-visible");
        }
        renderActions();
        return;
      }

      state.busy = true;
      renderActions();

      const configId = newId("cpc");
      const completesPendingSet = Boolean(matchingSetAvailable() && matchingSet?.setId);
      const setId = completesPendingSet
        ? matchingSet.setId
        : ((isHalsband || isLeine) ? newId("cpc-set") : null);

      const optionProperties = {};
      product.options.forEach((opt, index) => {
        optionProperties[opt.name] = state.selections[index];
      });

      const addonProperties = {
        "Paracord A": `${state.cordA.id} – ${state.cordA.name}`,
        "Paracord B": `${state.cordB.id} – ${state.cordB.name}`,
        "Produktart": productLabel,
        "Individuelle Anfertigung": "Ja",
        ...optionProperties,
        "_copcopet_config_id": configId
      };
      if (setId) addonProperties["_copcopet_set_id"] = setId;

      if (isLeine) {
        addonProperties["Paracord-Ausführung"] = "Leine";
      } else if (addon.endLength != null) {
        addonProperties["Paracord-Endlänge"] = `${addon.endLength} cm`;
      }

      const payload = {
        items: [
          {
            id: Number(variant.id),
            quantity: 1,
            properties: {
              "Konfiguration": "Paracord-Einflechtung",
              "Produktart": productLabel,
              "_copcopet_config_id": configId,
              ...(setId ? { "_copcopet_set_id": setId } : {})
            }
          },
          {
            id: Number(addon.variant.id),
            quantity: 1,
            parent_id: Number(variant.id),
            properties: addonProperties
          }
        ]
      };

      try {
        const response = await fetch(shopRoot() + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });

        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.description || data.message || "Warenkorb konnte nicht aktualisiert werden.");
        }

        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));

        if (isHalsband || isLeine) {
          if (completesPendingSet && matchingSet?.setId && setId === matchingSet.setId) {
            matchingSet = completedMatchingSet(matchingSet);
          } else {
            matchingSet = buildMatchingSet(setId);
          }

          state.setComplete = Boolean(matchingSet.hasHalsband && matchingSet.hasLeine);
          if (state.setComplete) {
            removeMatchingSet();
          } else {
            writeMatchingSet(matchingSet);
          }

          state.busy = false;
          state.cartAdded = true;
          renderSetSuccess();
          return;
        }

        window.location.href = shopRoot() + "cart";
      } catch (err) {
        const el = stepsHost.querySelector("[data-cart-error]");
        if (el) {
          el.textContent = err.message || String(err);
          el.classList.add("is-visible");
        }
        state.busy = false;
        renderActions();
      }
    }

    function mountPortal() {
      if (root.parentNode !== document.body) document.body.appendChild(root);
    }

    function restorePortal() {
      if (originMarker.parentNode && root.parentNode !== originMarker.parentNode) {
        originMarker.parentNode.insertBefore(root, originMarker.nextSibling);
      }
    }

    function openConfigurator() {
      state.step = 0;
      state.confirmed = false;
      state.cartAdded = false;
      state.matchingPromptDismissed = false;
      state.matchingApplied = false;
      state.setComplete = false;
      if (isLeine || isHalsband) matchingSet = readMatchingSet();
      mountPortal();
      render();
      overlay.hidden = false;
      document.documentElement.classList.add("cpc-page-locked");
      document.body.classList.add("cpc-page-locked");
      requestAnimationFrame(() => closeBtn.focus({ preventScroll: true }));
    }

    function closeConfigurator() {
      overlay.hidden = true;
      document.documentElement.classList.remove("cpc-page-locked");
      document.body.classList.remove("cpc-page-locked");
      restorePortal();
      requestAnimationFrame(() => openBtn.focus({ preventScroll: true }));
    }

    openBtn.addEventListener("click", openConfigurator);
    closeBtn.addEventListener("click", closeConfigurator);
    overlay.addEventListener("click", e => {
      if (e.target === overlay) closeConfigurator();
    });
    document.addEventListener("keydown", e => {
      if (!overlay.hidden && e.key === "Escape") closeConfigurator();
    });

    backBtn.addEventListener("click", () => {
      if (state.cartAdded && (isHalsband || isLeine)) {
        window.location.href = shopRoot() + "cart";
        return;
      }
      if (state.step > 0) {
        state.step--;
        content.scrollTop = 0;
        render();
      }
    });

    nextBtn.addEventListener("click", () => {
      if (state.cartAdded && (isHalsband || isLeine)) {
        if (state.setComplete) {
          window.location.href = shopRoot() + "cart";
        } else {
          window.location.href = shopRoot() + (isHalsband ? "collections/hundeleinen" : "collections/hundehalsbaender");
        }
        return;
      }
      if (state.step < wizard.length - 1) {
        state.step++;
        content.scrollTop = 0;
        render();
      } else {
        addToCart();
      }
    });
  }

  document.querySelectorAll("[data-cpc-root]").forEach(init);
  window.CopcoPetConfiguratorVersion = "9.8.10-high-variant-leinen";
})();
